import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useColors = create((set, get) => ({
    colors: [],
    ed: {},
    columns: [
        {
            title: 'Rangi kod',
            dataIndex: 'color',
            key: 'color',
            render: (text) => {
                return <div style={{ backgroundColor: text, width: 30, height: 30, borderRadius: 50 }} />
            }
        },
        {
            title: 'Rangi nomi',
            dataIndex: 'nameuz',
            key: 'nameuz',
        },
        {
            title: 'Rangi nomi',
            dataIndex: 'nameru',
            key: 'nameru',
        },
    ],
    setEd: (v) => {
        set({ ed: v })
    },
    getColors: () => {
        axios.get('/colors').then(res => {
            set({ colors: res.data })
        })
    },
    createColor: (v) => {
        axios.post('/colors', v).then(res => {
            get().getColors()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        })
    },
    updateColor: (v) => {
        axios.put('/colors/' + v.id, v).then(res => {
            get().getColors()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        })
    },
    deleteColor: (id) => {
        axios.delete('/colors/' + id).then(res => {
            get().getColors()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        })
    }
}))